package kz.dentalcrm.app.data.network.response_model.protocol_templates

import kotlinx.serialization.Serializable

@Serializable
data class ProtocolTemplate(
    val id: Int,
    val name: String? = null,
    val code: String? = null
)